import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
interface Clientes{
  value: number;
  name: string;
}
@Component({
  selector: 'app-agregar-cerveza',
  templateUrl: './agregar-cerveza.component.html',
  styleUrls: ['./agregar-cerveza.component.css']
})
export class AgregarCervezaComponent implements OnInit{

  cervezaCreada: boolean = false;
  waitAfterSave: boolean = false;

  //IMAGEN
  formData : FormData = new FormData();
  file: File | undefined;
  reader = new FileReader();
  imageUrl: string | ArrayBuffer | null = null;

  //ERROR
  nombreError: boolean = false;
  clienteIdError: boolean = false;
  showImageErrorMessage: boolean = false;
  errorMessage: string = "";
  errorFinal: boolean = false;
  nombreYaExisteError: boolean = false;
  cervezasData: any;

  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    nombre: new FormControl(''),
  });

  userData: any = [];

  private agregarProductoSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private cervezasSubscription: Subscription | undefined;

  constructor(private userService : UserService, private error429: Error429Service, private deviceService: DeviceService,
  private userDataService: UserDataService ){
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        if (this.userData.pro_id !== 4){
          this.selectedCliente = this.userData.cliente_id;
        }
      }
    });
    this.cervezasSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezasData = resp;
        console.log(this.cervezasData);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{}
    });
  }

  ngOnDestroy(): void {
    if (this.agregarProductoSubscription) {
      this.agregarProductoSubscription.unsubscribe();
    }
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.cervezasSubscription) {
      this.cervezasSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  previewImage() {
    this.reader.onload = () => {
      this.imageUrl = this.reader.result;
      /*if (typeof this.reader.result === 'string') {
        this.base64Image = this.reader.result.split(',')[1];
        console.log(this.base64Image);
      }*/
    };
    this.reader.readAsDataURL(this.file as Blob);
  }

  onFileSelected(event: any) {
    //this.file = (event.target as HTMLInputElement).files[0];
    this.file = event.target.files[0];
    if (this.file && this.file !==undefined && (this.file.type === 'image/jpeg' || this.file.type === 'image/png')) {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.formData.append('img', this.file as Blob);
    } else {
      console.log("no es png");
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  get nombreInput() { 
    return this.signin.get('nombre'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  guardarCliente(){
    //Error razonSocial vacio
    if(this.nombreInput?.value == ""){
      this.nombreError = true;
    } else{
      this.nombreError = false;
    }
    //Error Cliente seleccionado
    if (this.selectedCliente === undefined) {
      this.clienteIdError = true;
    } else {
      this.clienteIdError = false;
    }
    //Ver si el nombre de la cerveza ya existe
    this.nombreYaExisteError = this.cervezasData.some((cerveza:any) => cerveza.name === this.nombreInput?.value);
    if(this.nombreYaExisteError && this.userData.pro_id == 4){
      /*Si existe alguna cerveza con el mismo nombre miramos las cervezas del cliente seleccionado.
      Esto es importanto si eres ADMIN, sino eres admin no será necesario hacer este paso ya que
      las cervezas que le aparecen a un usuario solo son las suyas*/
      const cervezas = this.cervezasData.filter((cerveza:any) => cerveza.cliente_id === this.selectedCliente);
      this.nombreYaExisteError = cervezas.some((cerveza:any) => cerveza.name === this.nombreInput?.value);
    }

    //Si no hay errores el cliente se crea correctamente
    if(this.nombreError == false && this.clienteIdError == false && !this.showImageErrorMessage && !this.nombreYaExisteError){

      const productoData = new FormData();
      productoData.append('_method', "PUT");
      productoData.append('name', this.nombreInput?.value || '');
      productoData.append('img', this.file as Blob);
      productoData.append('cliente_id', this.selectedCliente?.toString() || '');
      
      this.agregarProductoSubscription = this.deviceService.createBeerType(productoData).subscribe({
        next: resp => {
          console.log(resp);
        },error: err =>{
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if(!this.waitAfterSave){
            this.waitAfterSave = true;
            this.cervezaCreada=true;
            setTimeout(() => {
              //Vaciar los valores de los inputs para que 
              this.signin.setValue({
                nombre: '',
              });
              this.selectedCliente = undefined;
              this.file = undefined;
              this.waitAfterSave = false;
              this.cervezaCreada = false;
            }, 3500);
          }
        }
      });
    }
    
    console.log("Nombre: ", this.nombreInput?.value);
    console.log("Cliente seleccionado: ", this.selectedCliente);
    console.log("Imagen: ", this.file as Blob);
    console.log('---------------------------------------');
  }

}
